// extracted by mini-css-extract-plugin
export default {"PrimaryButton":"button_PrimaryButton__4hQcq","cancelButton":"button_cancelButton__dL5vp","deleteBtn":"button_deleteBtn__8ZXyJ"};